<template>
  <div class="history-container">
    <mt-header class="dl_header_new_bg" fixed>
      <mt-button slot="left" @click.native="$router.back()">
        <img class="go-back" src="@/assets/img/ico_back.png" />
      </mt-button>
      <span>购买历史</span>
    </mt-header>

    <div class="history-list">
      <div v-if="historyRecords.length === 0" class="empty-state">
        暂无购买记录
      </div>
      <div v-else v-for="(record, index) in historyRecords" :key="index" class="history-item">
        <div class="record-header">
          <span class="time">{{ record.time }}</span>
          <span :class="['status', record.status]">{{ getStatusText(record.status) }}</span>
        </div>
        <div class="record-content">
          <div class="amount">
            <span class="label">订单编号：</span>
            <span class="value">{{ record.id }}</span>
          </div>
          <div class="amount">
            <span class="label">购买数量：</span>
            <span class="value">{{ record.amount }} MMT</span>
          </div>
          <div class="price">
            <span class="label">支付金额：</span>
            <span class="value">{{ record.price }} USDT</span>
          </div>
        </div>
        <!--<div class="record-actions">
          <router-link v-if="record.prize > record.prize_count" :to="{ path: '/lottery', query: { orderid: record.id }}" class="action-link">
            去抽奖
          </router-link>
           <router-link :to="{ path: '/lottery-history', query: { orderid: record.id }}" class="action-link">
            抽奖记录
          </router-link>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mmtOrder } from '@/api/index.js'
export default {
  name: 'PremmtHistory',
  data() {
    return {
      historyRecords: []
    }
  },
  activated() {
    this.getOrderList()
  },
  methods: {
    getOrderList() {
      mmtOrder().then(res => {
        if (res.code === 1) {
          this.historyRecords = res.data.map(item => ({
            id:item.id,
            time: item.time,
            prize: item.prize,
            prize_count: item.prize_count,
            status: this.convertStatus(item.status),
            amount: Number(item.total).toFixed(2),
            price: Number(item.amount).toFixed(2)
          }))
        }
      })
    },
    convertStatus(status) {
      // 根据后端返回的状态码转换为前端状态
      const statusMap = {
        1: 'success',  // 假设1代表成功
        0: 'pending',  // 假设0代表处理中
        2: 'failed'    // 假设2代表失败
      }
      return statusMap[status] || 'pending'
    },
    getStatusText(status) {
      const statusMap = {
        success: '交易成功',
        pending: '处理中',
        failed: '交易失败'
      }
      return statusMap[status] || status
    }
  }
}
</script>

<style scoped>
.history-container {
  padding: 60px 20px 20px;
  background-color: #f5f5f5;
  min-height: 100vh;
}

.go-back {
  width: 20px;
  height: 20px;
}

.history-list {
  margin-top: 20px;
}

.empty-state {
  text-align: center;
  color: #999;
  padding: 40px 0;
}

.history-item {
  background: #fff;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 15px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}

.record-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.time {
  color: #666;
  font-size: 14px;
}

.status {
  font-size: 14px;
  font-weight: 500;
}

.status.success {
  color: #52c41a;
}

.status.pending {
  color: #faad14;
}

.status.failed {
  color: #ff4d4f;
}

.record-content {
  font-size: 15px;
}

.record-content > div {
  margin: 8px 0;
}

.label {
  color: #666;
}

.value {
  color: #333;
  font-weight: 500;
}

.record-actions {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #eee;
}

.action-link {
  color: #1890ff;
  font-size: 14px;
  text-decoration: none;
}

.action-link:hover {
  color: #40a9ff;
}
</style>